import { FetchStatus } from '../../../../util/FetchStatus';
import { SALESCHANNEL_ARGOS } from '../InternetCalculatorInterfaces';
export const FIX_4G_EXCEPTION_CARD_OFFER_CODE = 'EXCEPTION_FIX4G';
export const FWA_TECHNOLOGIES = ['LTE', '5GNR'];
export const PON_TECHNOLOGIES = ['XGS-PON', 'GPON', 'ETH'];
export const DSL_TECHNOLOGIES = ['VDSL35B', 'VDSL17A', 'VDSL2', 'ADSL2+'];
export const resolveOfferIcon = (technology) => {
    if (['LTE'].includes(technology)) {
        return '#broadband';
    }
    else if (['5GNR'].includes(technology)) {
        return '#broadband';
    }
    else if (['GPON', 'VDSL2', 'XGS-PON', 'VDSL35B'].includes(technology)) {
        return '#fiber';
    }
    return '#fiber';
};
export const is5gTechnology = (technology) => technology === '5GNR';
export const resolveOfferOwnerLabel = (owner) => {
    if (!owner || owner === '0') {
        return 'internetCalculator.ownerLabel';
    }
    return `internetCalculator.ownerLabel.${owner}`;
};
export const createNewState = (prevState) => {
    return {
        ...prevState,
        internetOffers: {
            internetOfferCards: [],
            plannedInternetCards: [],
            showRequestForm: false
        },
        status: FetchStatus.UNINITIALIZED
    };
};
export const getInternetOffers = (calculatorState, internetCalculatorConfigState) => {
    var _a, _b;
    const fetchFinished = [FetchStatus.FETCHED, FetchStatus.ERROR].includes(calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.status);
    if (!!(calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.address) && fetchFinished) {
        return (((_a = calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.internetOffers) === null || _a === void 0 ? void 0 : _a.plannedInternetCards) || []).concat((_b = calculatorState === null || calculatorState === void 0 ? void 0 : calculatorState.internetOffers) === null || _b === void 0 ? void 0 : _b.internetOfferCards);
    }
    if ((internetCalculatorConfigState === null || internetCalculatorConfigState === void 0 ? void 0 : internetCalculatorConfigState.status) === FetchStatus.FETCHED) {
        return (internetCalculatorConfigState === null || internetCalculatorConfigState === void 0 ? void 0 : internetCalculatorConfigState.config.defaultOffers) || [];
    }
    return [];
};
export const resolveOfferCardProps = (isRecommended, isSuggested, inModal, properties) => {
    const isPlanned = properties.includes('PLANNED');
    const isConsultantInternetOffer = properties.includes('LIABLE_ONLY_FOR_SALES_CONSULTANT');
    const isOwned = properties.includes('OWNED');
    let background = isSuggested ? 'brand-primary-bg-subtle' : isRecommended ? 'brand-secondary-bg-subtle' : 'brand-secondary-bg-subtlest';
    let type = isPlanned && !inModal ? 'light' : undefined;
    const isActive = !!isSuggested;
    if (isPlanned || inModal) {
        background = 'neutral-bg-level-1';
    }
    if (isConsultantInternetOffer) {
        background = 'neutral-bg-level-1';
        type = 'employee';
    }
    if (isOwned && !inModal && !isSuggested) {
        return {};
    }
    return { background, type, isActive };
};
export const resolveOfferTag = (offer, translate, isRecommended, isSuggested) => {
    if (offer.properties.includes('LIABLE_ONLY_FOR_SALES_CONSULTANT')) {
        return { text: translate('internetCalculator.consultantException'), purpose: 'employee' };
    }
    if (isRecommended) {
        return { text: translate(`internetCalculator.${isSuggested ? 'suggested' : 'recommended'}`), purpose: 'recommended' };
    }
    if (offer.properties.includes('OWNED')) {
        return { text: translate('internetCalculator.ownedInternet'), purpose: 'success' };
    }
    return true;
};
export const formatPlanDueDate = (offer) => {
    const dueDate = new Date(offer.planDueDate);
    const addZeroes = (val) => (val.toString().length === 1 ? `0${val}` : val.toString());
    return `${addZeroes(dueDate.getDate())}.${addZeroes(dueDate.getMonth() + 1)}.${dueDate.getFullYear()}`;
};
export const isPlanDueDateInPast = (offer) => {
    const dueDate = new Date(offer.planDueDate);
    return dueDate <= new Date();
};
export const joinOfferNames = (internetOffers) => {
    const allOffers = (internetOffers.plannedInternetCards || []).concat(internetOffers.internetOfferCards || []);
    return allOffers.map((offer) => offer.productOfferingCode).join(', ');
};
export const mapInternetEditOffers = (offers, auth) => {
    if (!offers) {
        return [];
    }
    return offers.map((offer) => {
        var _a, _b, _c;
        return ({
            id: offer.uid,
            productOfferingCode: offer.code,
            price: `${auth.customer.type === 'B2B' ? (_a = offer.recurringPrice) === null || _a === void 0 ? void 0 : _a.amount.withoutVAT : (_b = offer.recurringPrice) === null || _b === void 0 ? void 0 : _b.amount.withVAT}`,
            priceWithoutVat: `${(_c = offer.recurringPrice) === null || _c === void 0 ? void 0 : _c.amount.withoutVAT}`,
            downloadSpeed: offer === null || offer === void 0 ? void 0 : offer.speed.downLink,
            uploadSpeed: offer === null || offer === void 0 ? void 0 : offer.speed.upLink,
            technology: offer.technology,
            salesChannel: offer.salesChannel,
            properties: offer.properties || [],
            isEdit: true,
            orderingUrl: offer.orderingUrl,
            skipOrderButtonModal: offer.skipOrderButtonModal,
            contractualUploadSpeed: offer.contractualUploadSpeed,
            contractualDownloadSpeed: offer.contractualDownloadSpeed,
            discounts: offer.discounts
        });
    });
};
export const addFix4gExceptionOfferCardIfNecessary = (offerCards, isDealer, urlData, address, room) => {
    const hasCardsThatAreNotFix4g = offerCards.some((card) => !['5GNR', 'LTE'].includes(card.technology));
    if (isDealer && hasCardsThatAreNotFix4g) {
        const path = '/teenused/internet/asukoht?productOfferingCode=' +
            `&addressData=${address.id}|${address.buildingId}` +
            `|${room && room.roomId ? room.roomId : ''}` +
            `|${room && room.roomName ? room.roomName : ''}`;
        const fix4gExceptionCard = {
            id: '',
            productOfferingCode: FIX_4G_EXCEPTION_CARD_OFFER_CODE,
            price: '',
            priceWithoutVat: '',
            properties: ['LIABLE_ONLY_FOR_SALES_CONSULTANT'],
            orderingUrl: urlData.getSelfServiceLink(path)
        };
        offerCards.push(fix4gExceptionCard);
    }
    return offerCards;
};
export const shouldShowOversoldWarning = (internetOfferCards, isDealer) => {
    const productCards = internetOfferCards;
    return isDealer && (productCards === null || productCards === void 0 ? void 0 : productCards.length) > 0 && !productCards.find((productCard) => !productCard.properties.includes('LIABLE_ONLY_FOR_SALES_CONSULTANT'));
};
export const shouldOrderWithArgos = (salesChannel) => {
    return SALESCHANNEL_ARGOS === salesChannel;
};
export const shouldShowArgosOrderNotice = (internetOfferCards, isDealer, offerFetchStatus) => {
    return (isDealer &&
        offerFetchStatus === FetchStatus.FETCHED &&
        (internetOfferCards === null || internetOfferCards === void 0 ? void 0 : internetOfferCards.length) > 0 &&
        internetOfferCards.some((offer) => shouldOrderWithArgos(offer.salesChannel)));
};
export const hasFWAOffers = (internetOffers) => {
    var _a;
    return (_a = internetOffers === null || internetOffers === void 0 ? void 0 : internetOffers.internetOfferCards) === null || _a === void 0 ? void 0 : _a.some((offer) => FWA_TECHNOLOGIES.includes(offer.technology));
};
export const hasOnlyFWAOffers = (internetOffers) => {
    var _a;
    return !((_a = internetOffers === null || internetOffers === void 0 ? void 0 : internetOffers.internetOfferCards) === null || _a === void 0 ? void 0 : _a.some((offer) => !FWA_TECHNOLOGIES.includes(offer.technology)));
};
export const hasDSLOffers = (internetOffers) => {
    var _a;
    return (_a = internetOffers === null || internetOffers === void 0 ? void 0 : internetOffers.internetOfferCards) === null || _a === void 0 ? void 0 : _a.some((offer) => DSL_TECHNOLOGIES.includes(offer.technology));
};
